module.exports = "<ag-grid-angular\r\n  class=\"container-ag-grid\"\r\n  [gridOptions]=\"gridOptions\"\r\n  [rowData]=\"gridData\"\r\n  [getRowStyle]=\"getRowStyle\"\r\n  (cellDoubleClicked)=\"onRowDoublicked($event)\"\r\n>\r\n</ag-grid-angular>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/posting/grid-posting-batch/grid-posting-batch.component.html
// module id = 2399
// module chunks = 66